var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "home-page page-main" },
    [
      [1, 2].indexOf(_vm.$store.getters.roles) > -1
        ? [_vm._m(0), _vm._v(" "), _c("homeTopAuditor")]
        : [
            _c(
              "div",
              { staticClass: "home-title-box spaceLeft" },
              [
                _c("div", { staticClass: "home-title" }, [
                  _vm._v(
                    "\n        Hi, Welcome to the production portal!\n      "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticClass: "home-ver",
                    class: { "is-active": _vm.userStatus != 0 },
                    attrs: {
                      round: "",
                      size: "small",
                      disabled: _vm.userStatus != 0,
                    },
                    on: { click: _vm.toAuthPage },
                  },
                  [_vm._v("Verification")]
                ),
                _vm._v(" "),
                _c(
                  "el-popover",
                  {
                    attrs: {
                      placement: "bottom",
                      trigger: "hover",
                      disabled: !_vm.$store.getters.annualInfo.isAnnualNav,
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "word-break": "break-word",
                          "font-size": "0.18rem",
                        },
                      },
                      [
                        _vm.$store.getters.annualInfo.isExpired
                          ? _c("div", [
                              _vm._v(
                                "\n            Please submit an application for annual review！\n          "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.$store.getters.annualInfo.isReject
                          ? _c("div", [_vm._v("Application rejected！")])
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.$store.getters.annualInfo.isAnnualNav
                      ? _c(
                          "span",
                          {
                            staticClass: "home-ver",
                            class: _vm.annualClassName,
                            attrs: { slot: "reference" },
                            on: { click: _vm.toAnnualPage },
                            slot: "reference",
                          },
                          [
                            _vm._v("\n          Annual Review\n          "),
                            _c("img", {
                              staticClass: "home-ver-warn",
                              attrs: {
                                src: require("@/assets/image/home/warn.png"),
                              },
                            }),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("homeTop"),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "home-title-box spaceLeft" }, [
      _c("div", { staticClass: "home-title" }, [
        _c("span", [_vm._v("Home Page")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }